import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { ArrowRight, ArrowLeft, Loader2, Upload, X, Camera } from "lucide-react";

export const ValuatorStep3 = ({ vf, photo, loading, onBack }) => {
  const { t } = useLang();
  const { form, update } = vf;
  const { photos, uploading, fileRef, cameraRef, onPickFiles, removePhoto } = photo;
  const hasPrice = parseFloat(form.purchase_price) > 0 || parseFloat(form.original_retail_price) > 0;

  return (
    <div data-testid="wizard-step-3" className="grid grid-cols-1 gap-6">
      <div className="bg-white border border-black p-8">
        <div className="flex items-center justify-between mb-6">
          <span className="overline">03 / {t.valuator.section_extras}</span>
          <span className="font-mono text-xs text-[#737373]">AI BOOST</span>
        </div>

        <label className="label-rv">{t.valuator.description}</label>
        <textarea data-testid="form-description" name="description" rows={4} className="input-rv resize-none" value={form.description} onChange={(e) => update("description", e.target.value)} />

        <div className="mt-6">
          <label className="label-rv">{t.valuator.photos}</label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {photos.map((p, i) => (
              <div key={p.path} data-testid={`photo-thumb-${i}`} className="relative border border-black bg-[#F5F5F5] aspect-square overflow-hidden group">
                <img src={p.preview} alt={`upload-${i}`} className="w-full h-full object-cover" />
                <button type="button" data-testid={`photo-remove-${i}`} onClick={() => removePhoto(i)} className="absolute top-1 right-1 bg-black text-white p-1 hover:bg-[#FF3B30] transition-colors" title={t.valuator.photo_remove}>
                  <X size={14} />
                </button>
              </div>
            ))}
            {photos.length < 3 && (
              <>
                <button
                  type="button"
                  data-testid="photo-upload-btn"
                  onClick={() => fileRef.current?.click()}
                  disabled={uploading}
                  className="aspect-square border-2 border-dashed border-black/40 hover:border-black hover:bg-[#F5F5F5] flex flex-col items-center justify-center gap-2 text-[#4A4A4A] disabled:opacity-50 transition-colors p-4 text-center"
                >
                  {uploading ? <Loader2 size={20} className="animate-spin" /> : <Upload size={20} />}
                  <span className="font-mono text-[10px] font-bold tracking-widest uppercase">{uploading ? t.valuator.photos_uploading : t.valuator.photos_drop}</span>
                  <span className="font-mono text-[9px] text-[#737373]">{t.valuator.photos_format}</span>
                </button>
                <button
                  type="button"
                  data-testid="photo-camera-btn"
                  onClick={() => cameraRef.current?.click()}
                  disabled={uploading}
                  className="aspect-square border-2 border-dashed border-[#002FA7]/40 hover:border-[#002FA7] hover:bg-[#002FA7]/5 flex flex-col items-center justify-center gap-2 text-[#002FA7] disabled:opacity-50 transition-colors p-4 text-center"
                >
                  <Camera size={20} />
                  <span className="font-mono text-[10px] font-bold tracking-widest uppercase">{t.valuator.take_photo}</span>
                </button>
              </>
            )}
          </div>
          <input data-testid="photo-file-input" ref={fileRef} type="file" multiple accept="image/jpeg,image/png,image/webp" className="hidden" onChange={onPickFiles} />
          <input data-testid="photo-camera-input" ref={cameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={onPickFiles} />
        </div>
      </div>

      <div className="hidden lg:flex items-center justify-between">
        <button type="button" data-testid="goto-step-2-back" onClick={onBack} className="btn-outline">
          <ArrowLeft size={16} /> {t.valuator.step_back}
        </button>
        <button data-testid="form-submit" type="submit" disabled={loading || uploading || !hasPrice} className="btn-primary">
          {loading ? (<><Loader2 size={18} className="animate-spin" /> {t.valuator.calculating}</>) : (<>{t.valuator.submit} <ArrowRight size={18} /></>)}
        </button>
      </div>
    </div>
  );
};

export default ValuatorStep3;
